// index.js

import Profile from './Profile';

export default Profile;



// WEBPACK FOOTER //
// ./src/comps/Profile/index.js